module.exports = __webpack_public_path__ + "img/1568cef.png";